













































































import { Component, Prop, Vue } from "vue-property-decorator";
import { msalService } from "./../../auth/msalService";
import store from "@/store/index";
import { AuthenticationConfiguration } from "@/types/store";
import { Getter } from "vuex-class";
import { AZNCONNECT_API } from "@/services/aznconnect-api";

@Component({
  components: {},
})
export default class UserProfileInfo extends Vue {
  loggedIn: boolean = false;

  // Niet null: de template leest Object.keys(profile) en profile.AllClaims al
  // bij de eerste render, voordat /user/current terug is.
  profile: any = { AllClaims: [] };

  @Getter("authenticationConfiguration")
  authenticationConfiguration!: AuthenticationConfiguration;

  async created() {
    if (
      store.getters.authenticationConfiguration.authenticationType === "msal"
    ) {
      // auto detect if user already logged in
      this.loggedIn = !!msalService.getAccount();
    }

    try {
      const response = await AZNCONNECT_API.get("/user/current"); // fixme todo
      console.log(response);
      this.profile = response.data;
    } catch (err) {
      console.error(err);
    }
  }
}
